import Hero from "@/components/sections/Hero";
import Marquee from "@/components/sections/Marquee";
import ServicesBento from "@/components/sections/ServicesBento";
import Testimonials from "@/components/sections/Testimonials";
import CTASection from "@/components/sections/CTASection";
import BrutalCard from "@/components/common/BrutalCard";
import SectionHeading from "@/components/common/SectionHeading";
import { Check } from "lucide-react";

const FEATURES = [
    {
        title: "Strategy that ships",
        copy: "We don't write 60-page decks. We deliver one-page plans paired with a working prototype within 10 days.",
        bullets: ["Discovery sprint", "1-page plan", "Working prototype"],
        bg: "yellow",
    },
    {
        title: "A pod, not a vendor",
        copy: "Each engagement gets a dedicated pod: product designer, full-stack engineer, growth marketer, and a partner you can text.",
        bullets: ["Dedicated team", "Direct Slack", "Weekly demos"],
        bg: "white",
    },
    {
        title: "Compounding outcomes",
        copy: "Our growth playbooks compound month-over-month. Most clients renew because the loops keep paying off.",
        bullets: ["Built-in analytics", "Loop-first growth", "Quarterly OKRs"],
        bg: "pink",
    },
];

export default function Home() {
    return (
        <div data-testid="home-page">
            <Hero />
            <Marquee />
            <ServicesBento />

            <section className="border-b-4 border-ink py-24 md:py-32 bg-paper">
                <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
                    <SectionHeading
                        eyebrow="How we work"
                        title="Less theatre. More throughput."
                    />
                    <div className="mt-14 grid md:grid-cols-3 gap-6">
                        {FEATURES.map((f, i) => (
                            <BrutalCard
                                key={f.title}
                                bg={f.bg}
                                interactive
                                className={i === 1 ? "md:translate-y-8" : ""}
                                data-testid={`home-feature-${i}`}
                            >
                                <span className="label-mono">0{i + 1}</span>
                                <h3 className="mt-4 font-display text-2xl md:text-3xl font-black leading-tight">
                                    {f.title}
                                </h3>
                                <p className="mt-3 font-body text-ink/75 leading-relaxed">
                                    {f.copy}
                                </p>
                                <ul className="mt-5 space-y-2">
                                    {f.bullets.map((b) => (
                                        <li key={b} className="flex items-center gap-2 font-body">
                                            <span className="w-5 h-5 rounded-full bg-ink text-cream flex items-center justify-center">
                                                <Check size={12} />
                                            </span>
                                            <span>{b}</span>
                                        </li>
                                    ))}
                                </ul>
                            </BrutalCard>
                        ))}
                    </div>
                </div>
            </section>

            <Testimonials />
            <CTASection />
        </div>
    );
}
